import { useSelector } from "react-redux";
import { selectState, setDeleteInputModalOpen } from "../inputSlice";
import Modal from "components/Modal/Modal";
import { useAppDispatch } from "hooks/hooks";
import { toast } from "react-toastify";

const DeleteRowModal = () => {
  const { deleteInputModalOpen, indexForOperation } = useSelector(selectState);
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(setDeleteInputModalOpen({ visible: false, index: -1 }));
  };

  const doDelete = async () => {
    try {
      // dispatch(deleteRow(indexForOperation));
      toast.success("Uspešno obrisan.");
      close();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Modal
      onClose={close}
      onClick={doDelete}
      isOpen={deleteInputModalOpen}
      title="Brisanje reda"
    >
      <p className="info-msg">
        Ovde brišete aktuelni red. Sledeći korak ne može se vratiti nazad!
      </p>
    </Modal>
  );
};

export default DeleteRowModal;
